export default __webpack_public_path__ + "static/media/contact-us-banner.e087f381.png";